<template>
    <el-card>
        <form
            @submit.prevent="fetchData(1)"
            class="pb-6 enter-query-form flex flex-wrap">
            <div class="flex items-center flex-wrap">
                <el-input
                    style="width: 270px;"
                    type="text"
                    v-model="form.keyword"
                    :placeholder="$t('Reception.Sixth.search')">
                </el-input>
                <span class="label-2">{{ $t('Common.store_tip') }}</span>
                <el-select
                    style="width: 130px;"
                    class="pr-2"
                    v-model="form.storeId"
                    :placeholder="$t('Common.store_placeholder')">
                    <el-option
                        v-for="(item, index) in stores"
                        :key="`${index}-${item.id}`"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <span class="label-2">{{ $t('Reception.Sixth.enter_time') }}</span>
                <el-date-picker
                    width="w/6"
                    class="mr-1"
                    v-model="date"
                    type="datetimerange"
                    :start-placeholder="$t('Common.start_time')"
                    :end-placeholder="$t('Common.end_time')"
                    :default-time="['00:00:00', '23:59:59']"
                    value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
                <el-select
                    style="width: 170px;margin-left: .5rem;"
                    v-model="form.temLockerStatus"
                    :placeholder="$t('Reception.Sixth.all_status')"
                    class="w-full"
                    clearable>
                    <el-option
                        v-for="(item, index) in options"
                        :key="`${index}-${item.code}`"
                        :label="item.name"
                        :value="item.code">
                    </el-option>
                </el-select>
                <el-select
                    style="width: 120px;margin: .5rem"
                    v-model="form.type"
                    :placeholder="$t('Reception.Sixth.enter_type')"
                    class="w-full" clearable>
                    <el-option
                        v-for="(item, index) in options2"
                        :key="`${index}-${item.code}`"
                        :label="item.name"
                        :value="item.code">
                    </el-option>
                </el-select>
                <el-button
                    type="primary"
                    native-type="submit">
                    {{ $t('Common.search') }}
                </el-button>
                <el-button @click="handleReset">{{ $t('Common.clear') }}</el-button>
            </div>
        </form>
        <div class="enterNumber">
            <span>{{ $t('Reception.Sixth.res') }}：{{ pagination.total }}人</span>
        </div>
        <el-table
            v-if="tableData"
            :data="tableData"
            v-loading="loading"
            class="my-4 w-full"
            border>
            <el-table-column prop="cardNum" :label="$t('Common.card_number')" />
            <el-table-column prop="clientName" :label="$t('Common.name')">
                <template slot-scope="{row}">
                    <div
                        class="fitness-blue cursor-pointer"
                        @click="handleUser(row.clientId)">
                        {{ row.clientName }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="gender" :label="$t('Common.gender')" />
            <el-table-column prop="clientPhone" :label="$t('Common.phone_phone')" />
            <el-table-column prop="temLockerCode" :label="$t('Reception.First.temporary')" />
            <el-table-column :label="$t('Reception.Fifth.tem_status')" width="120">
                <template slot-scope="{row}">
                    <div
                        :class="{'fitness-blue': Number(row.temLockerStatusCode) === 2}"
                        class="cursor-pointer"
                        @click="handleTemlock(row)">
                        {{ row.temLockerStatus }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="salesNickname" :label="$t('Common.saler')" />
            <el-table-column prop="coachNickname" :label="$t('Common.coach')" />
            <el-table-column prop="storeName" :label="$t('Common.enter_store')" />
            <el-table-column prop="cardName" :label="$t('Reception.Sixth.has_card')" />
            <el-table-column prop="type" :label="$t('Reception.Sixth.type')" />
            <el-table-column prop="deduction" :label="$t('Reception.Sixth.kou')" />
            <el-table-column prop="enterTime" :label="$t('Common.enter_time')" />
            <el-table-column prop="leaveTime" :label="$t('Common.outer_time')" />
            <el-table-column :label="$t('Reception.Sixth.inside')">
                <template slot-scope="{row}">
                    {{ row.duration ? `${row.duration}${$t('Common.minute')}` : '' }}
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            v-if="tableData && tableData.length"
            class="text-right"
            @current-change="fetchData"
            :current-page.sync="form.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
    </el-card>
</template>

<script>
  import {
    DatePicker,
    Table,
    TableColumn,
    Pagination,
    Tag,
    Tabs,
    Select,
    Option,
    Input,
  } from 'element-ui';
  import handleUser from '@/mixins/handleUser.js';

  export default {
    name: 'enter-query',
    components: {
      ElDatePicker: DatePicker,
      ElTable: Table,
      ElTableColumn: TableColumn,
      ElPagination: Pagination,
      ELSelect: Select,
      ElTag: Tag,
      ElTabs: Tabs,
      ElOption: Option,
      ElInput: Input,
    },
    mixins: [handleUser],
    data() {
        return {
            // 储物柜记录
            tableData: [],
            form: {
                page: 1,
                enterTimeFrom: null,
                enterTimeTo: null,
                keyword: null,
                storeId: null,
                temLockerStatus: null, // (1-已归还,2-未归还)
                type: null, // 入场类型(1-客户入场,2-临时入场,3-活动入场)
            },
            stores: [],
            pagination: {
                size: 10,
                total: 0,
            },
            options: [],
            options2: [],
            loading: false,
            update: false,
            // 时间
            date: null,
            eDate: null,
            loading: false,
            arr: [],
            eArr: [], // 空时间
        };
    },
    methods: {
        handleExport() {
            const form = Object.assign({}, this.form);
            if (this.date && (this.date !== this.arr)) {
                form.enterTimeFrom = this.date[0];
                form.enterTimeTo = this.date[1];
            } else {
                this.fetchTime();
            }
            API.post('export/entrance', form)
                .then(() => {
                    this.$router.push({
                        name: 'Setting.List',
                        query: {
                            activeName: 'sixth',
                        },
                    });
                });
            },
            // 时间获取
        fetchEmptyTime() {
                // let arr = [];
                const eDate = new Date();
                const eYear = eDate.getFullYear();
                let month = eDate.getMonth() + 1;
                let day = eDate.getDate();
                if (month < 10) month = `0${month}`;
                if (day < 10) day = `0${day}`;
                this.eArr[0] = `${eYear}-${month}-01 00:00:00`;
                this.eArr[1] = `${eYear}-${month}-${day} 23:59:59`;
                this.eDate = this.eArr;
            },
        handleReset() {
                this.form = {};
                this.date = null;
                this.fetchData(1);
            },
        fetchData(page = null) {
            if (page) this.form.page = page;
            // 获取当前月时间
            // if (!this.date) this.fetchTime();
            const form = Object.assign({}, this.form);
            // 起始时间修改
            if (this.date) {
                form.enterTimeFrom = this.date[0];
                form.enterTimeTo = this.date[1];
            } else {
                this.fetchEmptyTime();
                form.enterTimeFrom = '1970-01-01 00:00:00';
                form.enterTimeTo = this.eDate[1];
            }
            this.loading = true;
            API.get('entrance', {
                params: form,
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
            }).finally(() => this.loading = false);
        },
        // 时间获取
        fetchTime() {
            // let arr = [];
            const date = new Date();
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10) month = `0${month}`;
            if (day < 10) day = `0${day}`;
            this.arr[0] = `${year}-${month}-01 00:00:00`;
            this.arr[1] = `${year}-${month}-${day} 23:59:59`;
            this.date = this.arr;
        },
        fetchStore() {
            // 门店
            this.stores = [];
            API.get('store/list').then(res => {
            this.stores.push({
                id: null,
                name: this.$t('Common.all_store'),
            });
            this.stores = this.stores.concat(res);
            });
        },
        fetchAll() {
            API.get('constant/reception').then(res => {
            this.options = res.temLockerStatus;
            this.options2 = res.entranceType;
            });
        },
        handleTemlock(row) {
            // 0-无,1-已归还,2-未归还
            if (Number(row.temLockerStatusCode) !== 2) return;
            const id = row.temLockerId;
            const msg = `${this.$t('Message.temporary_whether')}${row.temLockerCode}？`;
            $ele.$confirm(msg, this.$t('Message.tip_title'), {
            confirmButtonText: this.$t('Message.confirm'),
            cancelButtonText: this.$t('Common.cancel'),
            type: 'warning',
            }).then(() => {
            API.put(`temporary-locker/return/${id}`).then(() => {
                $ele.$message.success(this.$t('Message.return_success'));
                this.fetchData();
            });
            }).catch(() => {
            // $ele.$message.info('已取消删除');
            });
        },
    },
    created() {
        this.fetchAll();
        this.fetchStore();
        this.fetchData();
    },
  };
</script>

<style lang="scss">
    .enter-query-form {
        border-bottom: 1px solid #e0e0e0;
        margin-bottom: 15px;
        .label-2 {
            margin: 0 .5rem 0 .5rem;
        }
        .el-date-editor {
            width: 366px;
        }
        .el-range-separator {
            width: auto;
        }
    }
    .enterNumber {
        margin-top: 20px;
        font-size: 12px;
    }
</style>
